import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import CalDate from 'caldate';
import CalEventMap from './CalEventMap.js';
import { calendar } from './internal/hijri-calendar.js';
var Hijri = /*#__PURE__*/function (_CalEventMap) {
  _inherits(Hijri, _CalEventMap);
  var _super = _createSuper(Hijri);
  function Hijri(opts) {
    var _this;
    _classCallCheck(this, Hijri);
    _this = _super.call(this, opts);
    _this.calendar = calendar;
    return _this;
  }
  _createClass(Hijri, [{
    key: "get",
    value: function get(timezone) {
      var _this2 = this;
      var arr = this.dates.map(function (date) {
        var cdate = new CalDate(date);
        var o = {
          date: cdate.toString() + ' -0600',
          start: cdate.setOffset(-6, 'h').toTimezone(timezone),
          end: cdate.toEndDate().toTimezone(timezone)
        };
        _this2._addSubstitute(date, o);
        return o;
      });
      return arr;
    }
  }]);
  return Hijri;
}(CalEventMap);
export { Hijri as default };